import React from 'react';
import VerificationComplianceSection from '../../../sections/AdminDashboard/VerificationCompliance/VerificationCompliance';

const VerificationCompliance = () => {
  return <VerificationComplianceSection />;
};

export default VerificationCompliance;


